import type { SignInMethods, SignUpMethods } from '@features/partners/builder/settings/sign-methods/models/sign-method';
import type { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class SignMethodsWebservice {
  readonly #http = inject(HttpClient);
  readonly #baseUrl = `${environment.api.obendy}/v1/partner-revision`;

  getSignInMethods(partnerId: string): Observable<SignInMethods> {
    return this.#http.get<SignInMethods>(`${this.#baseUrl}/${partnerId}/sign-in-methods`);
  }

  putSignInMethods(partnerId: string, signInMethods: SignInMethods): Observable<SignInMethods> {
    return this.#http.put<SignInMethods>(`${this.#baseUrl}/${partnerId}/sign-in-methods`, signInMethods);
  }

  getSignUpMethods(partnerId: string): Observable<SignUpMethods> {
    return this.#http.get<SignUpMethods>(`${this.#baseUrl}/${partnerId}/sign-up-methods`);
  }

  putSignUpMethods(partnerId: string, signUpMethods: SignUpMethods): Observable<SignUpMethods> {
    return this.#http.put<SignUpMethods>(`${this.#baseUrl}/${partnerId}/sign-up-methods`, signUpMethods);
  }
}
